import { configureStore } from "@reduxjs/toolkit";
import admin from "./slices/admin";
import reportSlice from "./slices/reports";
import contactSlice from "./slices/contact";
import loginSlice from "./slices/login";

export const store = configureStore({
  reducer: {
    admin: admin,
    report: reportSlice,
    contact: contactSlice,
    authentication: loginSlice,
  },
});
